import styled, { css } from 'styled-components';

type Props = {
  bold?: boolean;
};

export const Container = styled.div``;

export const Text = styled.div<Props>`
  vertical-align: middle;
  display: inline-block;
  ${props =>
    props.bold &&
    css`
      font-weight: 500;
    `}
`;

export const Icon = styled.div`
  vertical-align: middle;
  display: inline-block;
  margin: 0 10px;
  svg {
    display: block;
  }
`;
